import React from "react";
import { Container } from './styles';
import { Grid } from "@mui/material";
import { useRouter } from "next/router";
import { InsertPlan } from "./InsertPlan";
import { FinalDialog } from "./finalDialog";
import { DevolverPlan } from "./DevolverPlan";
import { ConfirmDialog } from "./ConfirmDialog";
import { PlansService } from "@/services/endpoints/plans";
import { ActionButtonElaborations } from "../../ActionButton";
import { usePreparationOfPlans } from "@/hooks/elaboracao_planos";
import { useSnackbarElaboration } from "@/hooks/useSnackbarElaboration";

export const SendingPlanForm = () => {
  const router = useRouter();
  const [open, setOpen] = React.useState(false);
  const { selectedItemsMenu } = usePreparationOfPlans();
  const [openFinal, setOpenFinal] = React.useState(false);
  const { PostEnviar, GetVinculoFinalValidacao } = new PlansService()
  const { toggleErrorSnackbar, toggleSuccessSnackbar } = useSnackbarElaboration();

  const handleConfirm = async () => {
    if (!router.query.id) return;

    try {
      const response = await GetVinculoFinalValidacao(router.query.id);
      const data = response.data.erros as any[];

      const notIsPending = data.length > 0 && Object.values(data).map(item => item.campo == 'Plano' && item.error == "Ok!")[0];

      if (notIsPending) {
        await PostEnviar(router.query.id);

        setOpen(false);
        setOpenFinal(true);
      } else {
        toggleErrorSnackbar("Envio do plano", "O plano precisa estar sem pendências para seguirmos com a aprovação.")
        setOpen(false);
      }
    } catch (err) {
      toggleErrorSnackbar('Envio do plano', 'Erro ao enviar o plano para aprovação')
    }
  }

  return (
    <Container>
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <div style={{ height: '1px', background: '#B4B4B4' }}></div>
        </Grid>
      </Grid>
      <ActionButtonElaborations sendingText="Enviar plano para revisão" onClick={() => {
        setOpen(true)
      }} layer_indicator={selectedItemsMenu?.layer_indicator} isOptional={'false'} />
      <ConfirmDialog open={open} handleClose={() => setOpen(false)} handleConfirm={() => { handleConfirm() }} />
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <DevolverPlan />
        <InsertPlan />
      </div>
      <FinalDialog open={openFinal} handleClose={() => { setOpenFinal(false), window.location.href = '/dashboard/elaboracao_planos' }} />
    </Container>
  )
}